export default "__VITE_ASSET__2zrOjbwl__"